import React from "react";
import "./styles/evv.css";
import Footer from "./Footer";

const EVVPage = () => {
  return (
    <div className="evv-container">
      {/* Hero Section */}
      <section className="hero">
        
     
      <div className="wrap"></div>
        <div className="container">

        <div className="hero-content">
          <h1>Electronic Visit Verification (EVV)</h1>
          <p>Ensuring compliance and accountability in home healthcare services.</p>
        </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="evv-content">
        <h2>What is EVV?</h2>
        <p>
          Electronic Visit Verification (EVV) is a system that verifies when, where, and 
          how home healthcare services are provided. It ensures transparency and helps 
          prevent fraud in Medicaid-funded services.
        </p>

        <h2>Why is EVV Important?</h2>
        <p>
          The 21st Century Cures Act mandates that all personal care services (PCS) and 
          home health care services (HHCS) must be electronically verified to ensure quality 
          and compliance.
        </p>

        <h2>How Does EVV Work?</h2>
        <ul>
          <li>✔ Caregivers clock in and out using an app, phone call, or device.</li>
          <li>✔ The system records time, date, location, caregiver details, and services provided.</li>
          <li>✔ Data is securely stored and sent to ensure compliance with regulations.</li>
        </ul>

        <h2>How to Get Started?</h2>
        <p>
          Contact us today to learn how our EVV solutions can help your agency stay compliant and 
          improve service efficiency.
        </p>
      </section>
      <section className="evv-download">
        <h2>Download the RevivingCare EVV App</h2>
        <p>Get started by downloading the app for your device:</p>
        <div className="download-buttons">
          <a
            href="https://apps.apple.com/us/app/revivingcare-evv/id1234567890"
            target="_blank"
            rel="noopener noreferrer"
            className="evv-btn apple"
          >
            📲 Download for Apple Devices
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.revivingcare.evv"
            target="_blank"
            rel="noopener noreferrer"
            className="evv-btn android"
          >
            🤖 Download for Android Devices
          </a>
        </div>
        <p>Once you’ve downloaded the app, log in using the unique username and password sent to you via text message.</p>
      </section>

      {/* Contact Section */}
      <section className="evv-content">
        <h2>Need Assistance?</h2>
        <p>Reach out to us for more details on how EVV works and how we can help you implement it smoothly.</p>
        <a href="/contact-us" className="evv-btn">Contact Us</a>
      </section>
      <footer>
        <Footer />
    </footer>
    </div>
    
  );
};

export default EVVPage;
